
import { BASE_URL } from "../../helpers/config";
import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import authorizedAxios from "../../helpers/authorizedAxios";
import { fetchProductGroups } from "../productGroupAction";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_PRODUCTS_LOADING = "SET_PRODUCTS_LOADING";
export const SET_PRODUCTS_ERROR = "SET_PRODUCTS_ERROR";

export const fetchPublicProducts = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get(
        "/public/products?limit=" + limit + "&page=" + page + "&search=" + search
      );

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PRODUCTS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PRODUCTS_LOADING, status: false });
    }
  };
};
export const fetchProducts = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/products?limit=" + limit + "&page=" + page + "&search=" + search);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PRODUCTS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PRODUCTS_LOADING, status: false });
    }
  };
};

export const getProductById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/products/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PRODUCTS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PRODUCTS_LOADING, status: false });
    }
  };
};

export const addProduct = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/products`, data), {
        loading: "Menyimpan data...",
        success: "Data produk berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data produk berhasil ditambahkan!"
        });
        dispatch(fetchProducts());
        dispatch(fetchProductGroups());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PRODUCTS_LOADING, status: false });
    }
  };
};
export const addProduction = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/productions`, data), {
        loading: "Menyimpan data...",
        success: "Data produksi berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data produksi berhasil ditambahkan!"
        });
        dispatch(fetchProducts());
        dispatch(fetchProductGroups());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PRODUCTS_LOADING, status: false });
    }
  };
};

export const updateProduct = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTS_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/products/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data produk berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data produk berhasil diupdate!"
        });
        dispatch(fetchProducts());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_PRODUCTS_LOADING, status: false });
    }
  };
};

export const deleteProduct = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/products/${id}`), {
        loading: "Menghapus data...",
        success: "Data produk berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data produk berhasil dihapus!"
        });
        dispatch(fetchProducts());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_PRODUCTS_LOADING, status: false });
    }
  };
};
